import { useOutletContext } from 'react-router-dom';

import { formatDate } from 'lib/helpers/dateUtils';
import { useGetImportMetadata } from 'lib/hooks/queries/practice/useGetImportMetadata';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

const PastImportsTable = ({ onViewPastImport }) => {
  const { practiceId } = useOutletContext();
  return (
    <AgTablePage
      noHeader
      onSelectRow={onViewPastImport}
      defaultColumns={[
        { field: 'id' },
        { field: 'fileName', headerName: 'File name' },
        {
          field: 'createdAt',
          headerName: 'Date',
          valueFormatter: ({ value }) => formatDate(value)
        }
      ]}
      useData={useGetImportMetadata}
      name="imports"
      title="Past imports"
      queryParams={{ practiceId }}
    />
  );
};

export default PastImportsTable;
